export default "/images/998e065eaafff4b59462f9dce2b11016.avif";